export default "/app/dist/public/main.css";